import pick from 'lodash/pick';

import config from '../config';
import { storableError } from '../util/errors';
import { addMarketplaceEntities } from '../ducks/marketplaceData.duck';
import { denormalisedResponseEntities } from '../util/data';
import {
  TRANSITION_ENQUIRE,
  TRANSITION_PROPOSAL,
  TRANSITION_PROPOSAL_DECLINE,
  TRANSITION_PROPOSAL_ACCEPT,
  TRANSITION_COUNTER_PROPOSAL,
  TRANSITION_REQUEST_PAYMENT_AFTER_COUNTER_PROPOSAL,
  TRANSITION_COUNTER_PROPOSAL_DECLINE,
  TRANSITION_COUNTER_PROPOSAL_ACCEPT, getProposalAmountWithProviderFee,
} from '../util/transactions';
import {
  fetchCurrentUser,
  fetchCurrentUserHasOrdersSuccess,
} from '../ducks/user.duck';
import {
  bookingCounterProposalAcceptedEventType, bookingCounterProposalDeclinedEventType,
  bookingCounterProposalEventType,
  bookingProposalAcceptedEventType,
  bookingProposalDeclinedEventType,
  bookingProposalRequestEventType,
  enquireAction
} from '../util/eventsHelpers/constants';
import { sendEventByAction } from '../util/eventsHelpers';
import { findNextBoundary, nextMonthFn, moment, monthIdStringInTimeZone } from '../util/dates';
import {initiateOrder} from "../containers/CheckoutPage/CheckoutPage.duck";
import {fetchTransaction} from "./transaction.duck";
import {CUSTOMER_COMMISSION_PERCENTAGE} from "@swimmy_/helpers";

// ================ Action types ================ //

export const SET_INITIAL_VALUES = 'app/listing/SET_INITIAL_VALUES';

export const SHOW_LISTING_REQUEST = 'app/listing/SHOW_LISTING_REQUEST';
export const SHOW_LISTING_ERROR = 'app/listing/SHOW_LISTING_ERROR';

export const FETCH_REVIEWS_REQUEST = 'app/listing/FETCH_REVIEWS_REQUEST';
export const FETCH_REVIEWS_SUCCESS = 'app/listing/FETCH_REVIEWS_SUCCESS';
export const FETCH_REVIEWS_ERROR = 'app/listing/FETCH_REVIEWS_ERROR';

export const FETCH_TIME_SLOTS_REQUEST = 'app/listing/FETCH_TIME_SLOTS_REQUEST';
export const FETCH_TIME_SLOTS_SUCCESS = 'app/listing/FETCH_TIME_SLOTS_SUCCESS';
export const FETCH_TIME_SLOTS_ERROR = 'app/listing/FETCH_TIME_SLOTS_ERROR';

export const SEND_ENQUIRY_REQUEST = 'app/listing/SEND_ENQUIRY_REQUEST';
export const SEND_ENQUIRY_SUCCESS = 'app/listing/SEND_ENQUIRY_SUCCESS';
export const SEND_ENQUIRY_ERROR = 'app/listing/SEND_ENQUIRY_ERROR';

export const DECLINE_PROPOSAL_REQUEST = 'app/listing/DECLINE_PROPOSAL_REQUEST';
export const DECLINE_PROPOSAL_SUCCESS = 'app/listing/DECLINE_PROPOSAL_SUCCESS';
export const DECLINE_PROPOSAL_ERROR = 'app/listing/DECLINE_PROPOSAL_ERROR';

export const ACCEPT_PROPOSAL_REQUEST = 'app/listing/ACCEPT_PROPOSAL_REQUEST';
export const ACCEPT_PROPOSAL_SUCCESS = 'app/listing/ACCEPT_PROPOSAL_SUCCESS';
export const ACCEPT_PROPOSAL_ERROR = 'app/listing/ACCEPT_PROPOSAL_ERROR';

export const COUNTER_PROPOSAL_REQUEST = 'app/listing/COUNTER_PROPOSAL_REQUEST';
export const COUNTER_PROPOSAL_SUCCESS = 'app/listing/COUNTER_PROPOSAL_SUCCESS';
export const COUNTER_PROPOSAL_ERROR = 'app/listing/COUNTER_PROPOSAL_ERROR';

export const ACCEPT_COUNTER_PROPOSAL_REQUEST = 'app/listing/ACCEPT_COUNTER_PROPOSAL_REQUEST';
export const ACCEPT_COUNTER_PROPOSAL_SUCCESS = 'app/listing/ACCEPT_COUNTER_PROPOSAL_SUCCESS';
export const ACCEPT_COUNTER_PROPOSAL_ERROR = 'app/listing/ACCEPT_COUNTER_PROPOSAL_ERROR';

export const DECLINE_COUNTER_PROPOSAL_REQUEST = 'app/listing/DECLINE_COUNTER_PROPOSAL_REQUEST';
export const DECLINE_COUNTER_PROPOSAL_SUCCESS = 'app/listing/DECLINE_COUNTER_PROPOSAL_SUCCESS';
export const DECLINE_COUNTER_PROPOSAL_ERROR = 'app/listing/DECLINE_COUNTER_PROPOSAL_ERROR';

// ================ Reducer ================ //

const initialState = {
  id: null,
  showListingError: null,
  reviews: [],
  fetchReviewsError: null,
  monthlyTimeSlots: {
    // '2019-12': {
    //   timeSlots: [],
    //   fetchTimeSlotsError: null,
    //   fetchTimeSlotsInProgress: null,
    // },
  },
  sendEnquiryInProgress: false,
  sendEnquiryError: null,
  declineProposalInProgress: false,
  declineProposalError: null,
  acceptProposalInProgress: false,
  acceptProposalError: null,
  counterProposalInProgress: false,
  counterProposalError: null,
  acceptCounterProposalInProgress: false,
  acceptCounterProposalError: null,
  declineCounterProposalInProgress: false,
  declineCounterProposalError: null,
};

const reducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_VALUES:
      return { ...initialState, ...payload };

    case SHOW_LISTING_REQUEST:
      return { ...state, id: payload.id, showListingError: null };
    case SHOW_LISTING_ERROR:
      return { ...state, showListingError: payload };

    case FETCH_REVIEWS_REQUEST:
      return { ...state, fetchReviewsError: null };
    case FETCH_REVIEWS_SUCCESS:
      return { ...state, reviews: payload };
    case FETCH_REVIEWS_ERROR:
      return { ...state, fetchReviewsError: payload };

    case FETCH_TIME_SLOTS_REQUEST: {
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [payload]: {
          ...state.monthlyTimeSlots[payload],
          fetchTimeSlotsError: null,
          fetchTimeSlotsInProgress: true,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_SUCCESS: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          timeSlots: payload.timeSlots,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_ERROR: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          fetchTimeSlotsError: payload.error,
        },
      };
      return { ...state, monthlyTimeSlots };
    }

    case SEND_ENQUIRY_REQUEST:
      return { ...state, sendEnquiryInProgress: true, sendEnquiryError: null };
    case SEND_ENQUIRY_SUCCESS:
      return { ...state, sendEnquiryInProgress: false };
    case SEND_ENQUIRY_ERROR:
      return { ...state, sendEnquiryInProgress: false, sendEnquiryError: payload };

    case DECLINE_PROPOSAL_REQUEST:
      return { ...state, declineProposalInProgress: true, declineProposalError: null };
    case DECLINE_PROPOSAL_SUCCESS:
      return { ...state, declineProposalInProgress: false };
    case DECLINE_PROPOSAL_ERROR:
      return { ...state, declineProposalInProgress: false, declineProposalError: payload };

    case ACCEPT_PROPOSAL_REQUEST:
      return { ...state, acceptProposalInProgress: true, acceptProposalError: null };
    case ACCEPT_PROPOSAL_SUCCESS:
      return { ...state, acceptProposalInProgress: false };
    case ACCEPT_PROPOSAL_ERROR:
      return { ...state, acceptProposalInProgress: false, acceptProposalError: payload };

    case COUNTER_PROPOSAL_REQUEST:
      return { ...state, counterProposalInProgress: true, counterProposalError: null };
    case COUNTER_PROPOSAL_SUCCESS:
      return { ...state, counterProposalInProgress: false };
    case COUNTER_PROPOSAL_ERROR:
      return { ...state, counterProposalInProgress: false, counterProposalError: payload };

    case ACCEPT_COUNTER_PROPOSAL_REQUEST:
      return { ...state, acceptCounterProposalInProgress: true, acceptCounterProposalError: null };
    case ACCEPT_COUNTER_PROPOSAL_SUCCESS:
      return { ...state, acceptCounterProposalInProgress: false };
    case ACCEPT_COUNTER_PROPOSAL_ERROR:
      return { ...state, acceptCounterProposalInProgress: false, acceptCounterProposalError: payload };

    case DECLINE_COUNTER_PROPOSAL_REQUEST:
      return { ...state, declineCounterProposalInProgress: true, declineCounterProposalError: null };
    case DECLINE_COUNTER_PROPOSAL_SUCCESS:
      return { ...state, declineCounterProposalInProgress: false };
    case DECLINE_COUNTER_PROPOSAL_ERROR:
      return { ...state, declineCounterProposalInProgress: false, declineCounterProposalError: payload };

    default:
      return state;
  }
};

export default reducer;

// ================ Action creators ================ //

export const setInitialValues = initialValues => ({
  type: SET_INITIAL_VALUES,
  payload: pick(initialValues, Object.keys(initialState)),
});

export const showListingRequest = id => ({
  type: SHOW_LISTING_REQUEST,
  payload: { id },
});

export const showListingError = e => ({
  type: SHOW_LISTING_ERROR,
  error: true,
  payload: e,
});

export const fetchReviewsRequest = () => ({ type: FETCH_REVIEWS_REQUEST });
export const fetchReviewsSuccess = reviews => ({ type: FETCH_REVIEWS_SUCCESS, payload: reviews });
export const fetchReviewsError = error => ({
  type: FETCH_REVIEWS_ERROR,
  error: true,
  payload: error,
});

export const fetchTimeSlotsRequest = monthId => ({
  type: FETCH_TIME_SLOTS_REQUEST,
  payload: monthId,
});
export const fetchTimeSlotsSuccess = (monthId, timeSlots) => ({
  type: FETCH_TIME_SLOTS_SUCCESS,
  payload: { timeSlots, monthId },
});
export const fetchTimeSlotsError = (monthId, error) => ({
  type: FETCH_TIME_SLOTS_ERROR,
  error: true,
  payload: { monthId, error },
});

export const sendEnquiryRequest = () => ({ type: SEND_ENQUIRY_REQUEST });
export const sendEnquirySuccess = () => ({ type: SEND_ENQUIRY_SUCCESS });
export const sendEnquiryError = e => ({ type: SEND_ENQUIRY_ERROR, error: true, payload: e });

export const acceptProposalRequest = () => ({ type: ACCEPT_PROPOSAL_REQUEST });
export const acceptProposalSuccess = () => ({ type: ACCEPT_PROPOSAL_SUCCESS });
export const acceptProposalError = e => ({ type: ACCEPT_PROPOSAL_ERROR, error: true, payload: e });

export const declineProposalRequest = () => ({ type: DECLINE_PROPOSAL_REQUEST });
export const declineProposalSuccess = () => ({ type: DECLINE_PROPOSAL_SUCCESS });
export const declineProposalError = e => ({ type: DECLINE_PROPOSAL_ERROR, error: true, payload: e });

export const counterProposalRequest = () => ({ type: COUNTER_PROPOSAL_REQUEST });
export const counterProposalSuccess = () => ({ type: COUNTER_PROPOSAL_SUCCESS });
export const counterProposalError = e => ({ type: COUNTER_PROPOSAL_ERROR, error: true, payload: e });

export const acceptCounterProposalRequest = () => ({ type: ACCEPT_COUNTER_PROPOSAL_REQUEST });
export const acceptCounterProposalSuccess = () => ({ type: ACCEPT_COUNTER_PROPOSAL_SUCCESS });
export const acceptCounterProposalError = e => ({ type: ACCEPT_COUNTER_PROPOSAL_ERROR, error: true, payload: e });

export const declineCounterProposalRequest = () => ({ type: DECLINE_COUNTER_PROPOSAL_REQUEST });
export const declineCounterProposalSuccess = () => ({ type: DECLINE_COUNTER_PROPOSAL_SUCCESS });
export const declineCounterProposalError = e => ({ type: DECLINE_COUNTER_PROPOSAL_ERROR, error: true, payload: e });

// ================ Thunks ================ //

export const showListing = (listingId, isOwn = false) => (dispatch, getState, sdk) => {
  dispatch(showListingRequest(listingId));
  dispatch(fetchCurrentUser());
  const params = {
    id: listingId,
    include: ['author', 'author.profileImage', 'images'],
    'fields.image': [
      // Listing page
      'variants.landscape-crop',
      'variants.landscape-crop2x',
      'variants.landscape-crop4x',
      'variants.landscape-crop6x',

      // Social media
      'variants.facebook',
      'variants.twitter',

      // Image carousel
      'variants.scaled-small',
      'variants.scaled-medium',
      'variants.scaled-large',
      'variants.scaled-xlarge',

      // Avatars
      'variants.square-small',
      'variants.square-small2x',
    ],
  };

  const show = isOwn ? sdk.ownListings.show(params) : sdk.listings.show(params);

  return show
    .then(data => {
      dispatch(addMarketplaceEntities(data));
      return data;
    })
    .catch(e => {
      dispatch(showListingError(storableError(e)));
    });
};

export const fetchReviews = listingId => (dispatch, getState, sdk) => {
  dispatch(fetchReviewsRequest());
  return sdk.reviews
    .query({
      listing_id: listingId,
      state: 'public',
      include: ['author', 'author.profileImage'],
      'fields.image': ['variants.square-small', 'variants.square-small2x'],
    })
    .then(response => {
      const reviews = denormalisedResponseEntities(response);
      dispatch(fetchReviewsSuccess(reviews));
    })
    .catch(e => {
      dispatch(fetchReviewsError(storableError(e)));
    });
};

const timeSlotsRequest = params => (dispatch, getState, sdk) => {
  return sdk.timeslots.query(params).then(response => {
    return denormalisedResponseEntities(response);
  });
};

export const fetchTimeSlots = (listingId, start, end, timeZone) => (dispatch, getState, sdk) => {
  const monthId = monthIdStringInTimeZone(start, timeZone);

  dispatch(fetchTimeSlotsRequest(monthId));

  // The maximum pagination page size for timeSlots is 500
  const extraParams = {
    per_page: 500,
    page: 1,
  };

  return dispatch(timeSlotsRequest({ listingId, start, end, ...extraParams }))
    .then(timeSlots => {
      dispatch(fetchTimeSlotsSuccess(monthId, timeSlots));
    })
    .catch(e => {
      dispatch(fetchTimeSlotsError(monthId, storableError(e)));
    });
};

const getProposalAmountWithoutFee = (amount) => {
  if (!amount) return null;

  return Math.round(amount / ((100 + CUSTOMER_COMMISSION_PERCENTAGE) / 100));
}

export const sendEnquiry = (listingId, message, bookingData, search, proposalPrice) => (dispatch, getState, sdk) => {
  dispatch(sendEnquiryRequest());
  const {
    bookingStart,
    bookingEnd,
    quantity,
    quantityHours,
  } = bookingData;
  const bodyParams = {
    transition: proposalPrice ? TRANSITION_PROPOSAL : TRANSITION_ENQUIRE,
    processAlias: config.bookingProcessAlias,
    params: {
      listingId,
      protectedData: {
        bookingStartDisplay: moment(bookingStart).toISOString(),
        bookingEndDisplay: moment(bookingEnd).toISOString(),
        date: moment(bookingStart).toISOString(),
        endDate: moment(bookingEnd).toISOString(),
        initiatedFromMobile: false,
        quantity,
        quantityHours,
        suggestionSearchParams: search,
        proposalPriceAmount: getProposalAmountWithoutFee(proposalPrice?.amount),
        proposalPriceCurrency: proposalPrice?.currency || null,
      },
    },
  };

  return sdk.transactions
    .initiate(bodyParams)
    .then(response => {
      const transactionId = response.data.data.id;

      // Send the message to the created transaction
      return sdk.messages.send({ transactionId, content: message }).then(() => {
        dispatch(sendEnquirySuccess());
        dispatch(fetchCurrentUserHasOrdersSuccess(true));
        sendEventByAction(transactionId.uuid, proposalPrice ? bookingProposalRequestEventType : enquireAction);
        return transactionId;
      });
    })
    .catch(e => {
      dispatch(sendEnquiryError(storableError(e)));
      throw e;
    });
};

export const declineProposal = (transactionId) => (dispatch, getState, sdk) => {
  dispatch(declineProposalRequest());

  const bodyParams = {
    id: transactionId,
    transition: TRANSITION_PROPOSAL_DECLINE,
    params: {},
  };

  return sdk.transactions
    .transition(bodyParams)
    .then(() => {
      dispatch(declineProposalSuccess());
      sendEventByAction(transactionId, bookingProposalDeclinedEventType);
    })
    .catch(e => {
      dispatch(declineProposalError(storableError(e)));
      throw e;
    });
};

export const acceptProposal = (transactionId, orderParams) => (dispatch, getState, sdk) => {
  dispatch(acceptProposalRequest());
  return initiateOrder(orderParams, transactionId)(dispatch, getState, sdk)
    .then(async () => {
      await sleep(2000);
      dispatch(fetchTransaction(transactionId))
      dispatch(acceptProposalSuccess());
      sendEventByAction(transactionId, bookingProposalAcceptedEventType);
    })
    .catch(e => {
      dispatch(acceptProposalError(storableError(e)));
      throw e;
    });
  // const bodyParams = {
  //   id: transactionId,
  //   transition: TRANSITION_PROPOSAL_ACCEPT,
  //   params: {},
  // };
  //
  // return sdk.transactions
  //   .transition(bodyParams)
  //   .then(() => {
  //     dispatch(acceptProposalSuccess());
  //     sendEventByAction(transactionId, bookingProposalAcceptedEventType);
  //   })
  //   .catch(e => {
  //     dispatch(acceptProposalError(storableError(e)));
  //     throw e;
  //   });
};

export const counterProposal = (transactionId, counterProposalPriceAmount) => (dispatch, getState, sdk) => {
  dispatch(counterProposalRequest());

  const bodyParams = {
    id: transactionId,
    transition: TRANSITION_COUNTER_PROPOSAL,
    params: {
      protectedData: {
        counterProposalPriceAmount: getProposalAmountWithProviderFee(counterProposalPriceAmount),
      },
    },
  };

  return sdk.transactions
    .transition(bodyParams)
    .then(() => {
      dispatch(counterProposalSuccess());
      sendEventByAction(transactionId, bookingCounterProposalEventType);
    })
    .catch(e => {
      dispatch(counterProposalError(storableError(e)));
      throw e;
    });
};

const sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}


export const acceptCounterProposal = (transactionId, orderParams) => (dispatch, getState, sdk) => {
  dispatch(acceptCounterProposalRequest());
  return initiateOrder(orderParams, transactionId)(dispatch, getState, sdk)
    .then(async () => {
      await sleep(5000);
      dispatch(fetchTransaction(transactionId))
      dispatch(declineCounterProposalSuccess());
      sendEventByAction(transactionId, bookingCounterProposalAcceptedEventType);
    })
    .catch((e) => {
      dispatch(declineCounterProposalError(storableError(e)));
      throw e;
    });
  // const bodyParams = {
  //   id: transactionId,
  //   transition: TRANSITION_COUNTER_PROPOSAL_ACCEPT,
  //   params: {},
  // };
  //
  // return sdk.transactions
  //   .transition(bodyParams)
  //   .then(() => {
  //     dispatch(declineCounterProposalSuccess());
  //     sendEventByAction(transactionId, bookingCounterProposalAcceptedEventType);
  //   })
  //   .catch((e) => {
  //     dispatch(declineCounterProposalError(storableError(e)));
  //     throw e;
  //   });
};

export const declineCounterProposal = (transactionId) => (dispatch, getState, sdk) => {
  dispatch(declineCounterProposalRequest());

  const bodyParams = {
    id: transactionId,
    transition: TRANSITION_COUNTER_PROPOSAL_DECLINE,
    params: {},
  };

  return sdk.transactions
    .transition(bodyParams)
    .then(() => {
      dispatch(declineCounterProposalSuccess());
      sendEventByAction(transactionId, bookingCounterProposalDeclinedEventType);
    })
    .catch((e) => {
      dispatch(declineCounterProposalError(storableError(e)));
      throw e;
    });
};

// Helper function for loadData call.
export const fetchMonthlyTimeSlots = (dispatch, listing, bookingDate) => {
  const hasWindow = typeof window !== 'undefined';
  const attributes = listing.attributes;
  // Listing could be ownListing entity too, so we just check if attributes key exists
  const hasTimeZone =
    attributes && attributes.availabilityPlan && attributes.availabilityPlan.timezone;

  // Fetch time-zones on client side only.
  if (hasWindow && listing.id && hasTimeZone) {
    const tz = listing.attributes.availabilityPlan.timezone;
    const today = new Date();
    const isNextMonth = bookingDate && moment(bookingDate).isAfter(today, 'month');
    const currentMonth = isNextMonth ? moment(bookingDate).startOf('month').toDate() : today;
    const nextBoundary = findNextBoundary(tz, currentMonth);

    const nextMonth = nextMonthFn(nextBoundary, tz);
    const nextAfterNextMonth = nextMonthFn(nextMonth, tz);

    return Promise.all([
      dispatch(fetchTimeSlots(listing.id, nextBoundary, nextMonth, tz)),
      dispatch(fetchTimeSlots(listing.id, nextMonth, nextAfterNextMonth, tz)),
    ]);
  }

  // By default return an empty array
  return Promise.all([]);
};
